// src/services/auth.service.js
import axios from 'axios'
import Cookies from 'js-cookie'
import { v4 as uuidv4 } from 'uuid'

const API_URL = process.env.REACT_APP_BACKEND_URL

export const login = async (identifier, password) => {
  try {
    const response = await axios.post(`${API_URL}/api/auth/local`, {
      identifier,
      password,
    })
    const jwt = response.data?.jwt
    if (jwt) {
      Cookies.set('access_token', jwt, {
        path: '/',
        domain: window.location.hostname,
        expires: 1,
      })
      Cookies.set('uuid', uuidv4(), {
        path: '/',
        domain: window.location.hostname,
        expires: 1,
      })
    }
    return response.data
  } catch (error) {
    console.error('Error during login:', error)
    throw error
  }
}
